import { render, staticRenderFns } from "./page-element-social-links.vue?vue&type=template&id=755ca7da&scoped=true"
import script from "./page-element-social-links.vue?vue&type=script&lang=js"
export * from "./page-element-social-links.vue?vue&type=script&lang=js"
import style0 from "./page-element-social-links.vue?vue&type=style&index=0&id=755ca7da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755ca7da",
  null
  
)

export default component.exports